// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    padding: 2rem 1rem 1rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    max-width: max-content;
    min-width: 14rem;
    width: 14rem;
    overflow-y: scroll;
    height:88vh;
    /* border-right: 1px solid var(--gray); */
    box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}

.sidebar_button_container {
    display: flex;
    flex-direction: column;
    gap: .2rem;
    width: 100%;
}


.sidebar_btn_active {
    outline: none;
    border: none;
    width: 100%;
    padding: 0.5rem 1rem;
    background-color: var(--primary_color);
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    border-radius: var(--border-radius);
    text-align: left;
    &:hover {
        color: var(--white) !important;
    }
}

.sidebar_btn_active > svg{
    font-size: 1.5rem;
    color: var(--white);
    cursor: pointer;
}
.sidebar_btn_deactive {
    outline: none;
    border: none;
    width: 100%;
    padding: 0.5rem 1rem;
    background-color: transparent;
    color: var(--primary_color);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    text-align: left;
    font-size: 1.1rem;

    &:hover {
        background-color: var(--hover_primary_color) !important;
    }
}
.sidebar_btn_deactive > svg{
    font-size: 1.5rem;
    color: var(--primary_color);
    cursor: pointer;
}


.sidebar_btn_active_sub {
    border-top: none;
    background-color: var(--white) !important;
    /* border-left: 1px solid rgb(89, 83, 83); */
    width: 100%;
    animation: fadeIn 0.3s linear;
    /* padding: 0.5rem 1rem .5rem 1rem; */
}

@keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  

.sidebar_btn_active_sub_a {
    display: inherit;
    outline: none;
    font-size: 1.1rem;
    /* width: 100%; */
    background-color: var(--gray);
    color: var(--white);
    gap: 0.5rem;
    border-radius: var(--border-radius);
    /* border-left: 1px solid red; */
    padding: 0.5rem;
    margin-left: 1.5rem;
}
.sidebar_btn_deactive_sub_a{
    outline: none;
    /* width: 100%; */
    background-color: transparent;
    color: var(--primary_color);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    text-align: left;
    font-size: 1.1rem;
    padding: 0.5rem;
    margin-left: 1.5rem;
    /* border-left: 1px solid var(--gray); */

    &:hover {
        background-color: var(--lgray) !important;
    }
}

@media screen and (max-width: 1025px) {
    .sidebar {
        display: none;
    }
}




.DemoDashboard {
    display: flex;
    justify-content: space-between;
    overflow-y: scroll;
    height: 88vh;
}

.Right_container {
    flex: 80% 1;
    overflow-y: scroll;
    height: 88vh;
    padding: 3rem 1rem 1rem 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,yCAAyC;IACzC,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,mCAAmC;IACnC,gBAAgB;IAChB;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,6BAA6B;IAC7B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,iBAAiB;;IAEjB;QACI,uDAAuD;IAC3D;AACJ;AACA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,4CAA4C;IAC5C,WAAW;IACX,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;EACrB;;;AAGF;IACI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,mCAAmC;IACnC,gCAAgC;IAChC,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,wCAAwC;;IAExC;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;;;;AAKA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC","sourcesContent":[".sidebar {\n    padding: 2rem 1rem 1rem 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1.5rem;\n    max-width: max-content;\n    min-width: 14rem;\n    width: 14rem;\n    overflow-y: scroll;\n    height:88vh;\n    /* border-right: 1px solid var(--gray); */\n    box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;\n}\n\n.sidebar_button_container {\n    display: flex;\n    flex-direction: column;\n    gap: .2rem;\n    width: 100%;\n}\n\n\n.sidebar_btn_active {\n    outline: none;\n    border: none;\n    width: 100%;\n    padding: 0.5rem 1rem;\n    background-color: var(--primary_color);\n    color: var(--white);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    border-radius: var(--border-radius);\n    text-align: left;\n    &:hover {\n        color: var(--white) !important;\n    }\n}\n\n.sidebar_btn_active > svg{\n    font-size: 1.5rem;\n    color: var(--white);\n    cursor: pointer;\n}\n.sidebar_btn_deactive {\n    outline: none;\n    border: none;\n    width: 100%;\n    padding: 0.5rem 1rem;\n    background-color: transparent;\n    color: var(--primary_color);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    text-align: left;\n    font-size: 1.1rem;\n\n    &:hover {\n        background-color: var(--hover_primary_color) !important;\n    }\n}\n.sidebar_btn_deactive > svg{\n    font-size: 1.5rem;\n    color: var(--primary_color);\n    cursor: pointer;\n}\n\n\n.sidebar_btn_active_sub {\n    border-top: none;\n    background-color: var(--white) !important;\n    /* border-left: 1px solid rgb(89, 83, 83); */\n    width: 100%;\n    animation: fadeIn 0.3s linear;\n    /* padding: 0.5rem 1rem .5rem 1rem; */\n}\n\n@keyframes fadeIn {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n  }\n  \n\n.sidebar_btn_active_sub_a {\n    display: inherit;\n    outline: none;\n    font-size: 1.1rem;\n    /* width: 100%; */\n    background-color: var(--gray);\n    color: var(--white);\n    gap: 0.5rem;\n    border-radius: var(--border-radius);\n    /* border-left: 1px solid red; */\n    padding: 0.5rem;\n    margin-left: 1.5rem;\n}\n.sidebar_btn_deactive_sub_a{\n    outline: none;\n    /* width: 100%; */\n    background-color: transparent;\n    color: var(--primary_color);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.5rem;\n    text-align: left;\n    font-size: 1.1rem;\n    padding: 0.5rem;\n    margin-left: 1.5rem;\n    /* border-left: 1px solid var(--gray); */\n\n    &:hover {\n        background-color: var(--lgray) !important;\n    }\n}\n\n@media screen and (max-width: 1025px) {\n    .sidebar {\n        display: none;\n    }\n}\n\n\n\n\n.DemoDashboard {\n    display: flex;\n    justify-content: space-between;\n    overflow-y: scroll;\n    height: 88vh;\n}\n\n.Right_container {\n    flex: 80%;\n    overflow-y: scroll;\n    height: 88vh;\n    padding: 3rem 1rem 1rem 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
